import { clsx } from "clsx";

type Color = "gray" | "blue" | "green" | "red" | "yellow" | "purple" | "orange" | "black";

interface BadgeProps {
  color?: Color;
  children: React.ReactNode;
  className?: string;
  /** Tooltip — np. pełne wyjaśnienie skrótowej etykiety. */
  title?: string;
}

const colors: Record<Color, string> = {
  gray: "bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)] border border-[var(--color-border)]",
  blue: "bg-blue-50 text-blue-700 border border-blue-200",
  green: "bg-green-50 text-green-700 border border-green-200",
  red: "bg-red-50 text-red-700 border border-red-200",
  yellow: "bg-amber-50 text-amber-700 border border-amber-200",
  purple: "bg-purple-50 text-purple-700 border border-purple-200",
  orange: "bg-orange-50 text-orange-700 border border-orange-200",
  black: "bg-gray-900 text-gray-100 border border-gray-700",
};

export function Badge({ color = "gray", children, className, title }: BadgeProps) {
  return (
    <span
      title={title}
      className={clsx(
        "inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-mono font-medium uppercase tracking-wide",
        colors[color],
        className,
      )}
    >
      {children}
    </span>
  );
}
